import type { PrescriptionPadReviewAction } from '@/components/Patient/components/PrescriptionPad';
import { Checkbox, Typography } from '@montugroup/design-system';
import { Box, FormControlLabel, FormGroup, Stack } from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';

const StyledFormControlLabel = styled(FormControlLabel)(({ theme }) => ({
  '& .MuiFormControlLabel-label': {
    ...theme.typography.body2,
    color: theme.palette.text.primary,
  },
}));

export interface ConfirmationCheckListProps {
  actions: PrescriptionPadReviewAction[];
  onClick: (action: PrescriptionPadReviewAction) => void;
}

export const ConfirmationCheckList = ({ actions = [], onClick }: ConfirmationCheckListProps) => {
  const theme = useTheme();

  return (
    <Box sx={{ padding: theme.spacing(8) }}>
      <Stack direction="column" spacing={1} mb={theme.spacing(2)}>
        <Typography variant="body1" color={theme.palette.text.primary} fontWeight="bold">
          Have you completed all required actions?
        </Typography>

        <Typography variant="body2" color={theme.palette.text.secondary}>
          Please review and complete any outstanding items before confirming.
        </Typography>
      </Stack>

      <FormGroup>
        {actions.map((action) => (
          <StyledFormControlLabel
            key={`confirmation-checklist-${action.id}`}
            control={
              <Checkbox
                checked={action.checked}
                onChange={() =>
                  onClick({
                    ...action,
                    checked: !action.checked,
                  })
                }
                name={`confirmation-checklist-${action.id}`}
              />
            }
            label={action.label}
          />
        ))}
      </FormGroup>
    </Box>
  );
};
